import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from '../../../../components/navigation';
import { getExtensionsList } from '../../actions';
import { selectExtensionsList } from '../../selectors';
import { addToast } from '../../../core/actions';
import { ToastType, localeService } from '../../../core';
export const AdminExtensionList = () => {
    const extensions = useSelector(selectExtensionsList);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        const fetchData = () => {
            setIsLoading(true);
            try {
                dispatch(getExtensionsList());
            }
            catch {
                const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
                dispatch(addToast(ToastType.error, errorMessage));
            }
            setIsLoading(false);
        };
        fetchData();
    }, [dispatch]);
    return (<div>
      <header className="settings-header">
        <h2 className="header-title">{localeService.formatMessageById('account.extensions.new-title')}</h2>
        <p className="header-description">Browse, edit and add tools.</p>
      </header>
      <div>
        {!isLoading && (<table className="table table-striped">
            <thead>
            <tr>
              <th style={{ width: '50px' }}>id</th>
              <th>title</th>
              <td>short description</td>
              <td>status</td>
              <th style={{ width: '120px', textAlign: 'center' }}>actions</th>
            </tr>
            </thead>
            <tbody>
            {extensions.map(extension => (<tr key={extension.id}>
                <td>{extension.id}</td>
                <td>{extension.title}</td>
                <td>{extension.shortDescription}</td>
                <td>{extension.status}</td>
                <td style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Link to={`/account/admin/extensions/edit/${extension.id}`}>edit</Link>
                  <Link to={`/account/admin/extensions/statistics/${extension.id}`}>statistics</Link>
                </td>
              </tr>))}
            </tbody>
          </table>)}
      </div>

      <footer className="settings-footer">
        <Link to={'/account/admin/extensions/create'} className="button button--stroke">Create new Tool</Link>
      </footer>
    </div>);
};
